import { Button, ButtonProps, styled } from '@mui/material';

interface SecondaryButtonProps extends ButtonProps {
  'data-testid'?: string;
}

const SecondaryButton = styled(Button)<SecondaryButtonProps>({
  backgroundColor: '#ffffff',
  fontFamily: 'Ubuntu',
  border: '1px solid #dedbd6',
  color: '#171414',
  '&:hover': {
    backgroundColor: '#f7f6f4',
  },
  '&:disabled': {
    backgroundColor: '#efedea',
    color: '#766e68;',
  },
});

export default SecondaryButton;
